const DISABLED_ANALYTICS_HOSTNAMES = new Set([
  'staging.clubeda42.com.br',
  'localhost',
  '127.0.0.1',
]);

export const isAnalyticsEnabled = (): boolean => {
  if (typeof window === 'undefined') {
    return true;
  }

  return !DISABLED_ANALYTICS_HOSTNAMES.has(window.location.hostname);
};
